import { buildEmbedSrc } from './utils';

( function () {
	function createIframe( wrapper ) {
		const pageUrl    = wrapper.dataset.pageUrl    || '';
		const tabs       = ( wrapper.dataset.tabs || 'timeline' ).split( ',' );
		const dataHeight = parseInt( wrapper.dataset.height, 10 );
		// data-height="0" means full-height mode — measure the live rendered height.
		const height     = dataHeight || wrapper.clientHeight || 500;
		const smallHeader = wrapper.dataset.smallHeader === '1';
		const hideCover   = wrapper.dataset.hideCover   === '1';
		const showFacepile = wrapper.dataset.showFacepile === '1';

		const width = wrapper.clientWidth || 500;
		const src = buildEmbedSrc( { pageUrl, tabs, width, height, smallHeader, hideCover, showFacepile } );
		if ( ! src ) return null;

		const iframe = document.createElement( 'iframe' );
		iframe.src = src;
		iframe.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;border:none;';
		iframe.setAttribute( 'loading', 'lazy' );
		iframe.setAttribute( 'allowfullscreen', '' );
		iframe.setAttribute( 'title', 'Facebook Page Embed' );

		const skeleton = wrapper.querySelector( '.fb-embed-skeleton' );
		if ( skeleton ) {
			wrapper.replaceChild( iframe, skeleton );
		} else {
			wrapper.insertBefore( iframe, wrapper.firstChild );
		}

		return iframe;
	}

	function attachResponsiveObserver( wrapper, iframe ) {
		let debounceTimer = null;

		const ro = new ResizeObserver( () => {
			clearTimeout( debounceTimer );
			debounceTimer = setTimeout( () => {
				const pageUrl    = wrapper.dataset.pageUrl    || '';
				const tabs       = ( wrapper.dataset.tabs || 'timeline' ).split( ',' );
				const dataHeight = parseInt( wrapper.dataset.height, 10 );
				const height     = dataHeight || wrapper.clientHeight || 500;
				const smallHeader  = wrapper.dataset.smallHeader  === '1';
				const hideCover    = wrapper.dataset.hideCover    === '1';
				const showFacepile = wrapper.dataset.showFacepile === '1';
				const width = wrapper.clientWidth || 500;

				const newSrc = buildEmbedSrc( { pageUrl, tabs, width, height, smallHeader, hideCover, showFacepile } );
				if ( newSrc ) {
					iframe.src = newSrc;
				}
			}, 300 );
		} );

		ro.observe( wrapper );
		return ro;
	}

	function initBlock( wrapper ) {
		const isLazy       = wrapper.dataset.lazy       === '1';
		const isResponsive = wrapper.dataset.responsive === '1';

		if ( isLazy ) {
			const io = new IntersectionObserver(
				( entries, observer ) => {
					entries.forEach( ( entry ) => {
						if ( ! entry.isIntersecting ) return;
						observer.unobserve( wrapper );
						const iframe = createIframe( wrapper );
						if ( iframe && isResponsive ) {
							attachResponsiveObserver( wrapper, iframe );
						}
					} );
				},
				{ rootMargin: '200px' }
			);
			io.observe( wrapper );
		} else {
			const iframe = createIframe( wrapper );
			if ( iframe && isResponsive ) {
				attachResponsiveObserver( wrapper, iframe );
			}
		}
	}

	document.addEventListener( 'DOMContentLoaded', function () {
		document
			.querySelectorAll( '.wp-block-gandaki-govt-facebook-page-embed' )
			.forEach( initBlock );
	} );
} )();
